/**
 * This function is used to correct the label for the filters.
 *
 * @param {string} label - The label to correct.
 * @returns {string} The corrected label.
 */
export const useCorrectFiltersLabel = label => {
  switch (label) {
    case 'diagnosis': // we are using Admission for instead of Diagnosis for care details
      return 'admissionFor'
    default:
      return label
  }
}
